import axios from "axios";
import { useInfiniteQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const companies = async (pageParams = 1) =>
  axios.get(Routes.COMPANIES + "?page=" + pageParams);

export const useCompanies = () => {
  return useInfiniteQuery({
    queryKey: [Keys.COMPANIES_QRY],
    queryFn: ({ pageParam = 1 }) => companies(pageParam),
    getNextPageParam: (lastPage) => {
      return lastPage.data.links.next
        ? lastPage.data.meta.current_page + 1
        : null;
    },
    getPreviousPageParam: (firstPage) => firstPage.data.links.prev,
    cacheTime: 0,
  });
};
